import { render, staticRenderFns } from "./ProRetouchersOrderEducationCheck.vue?vue&type=template&id=5ec4d158&"
import script from "./ProRetouchersOrderEducationCheck.vue?vue&type=script&lang=js&"
export * from "./ProRetouchersOrderEducationCheck.vue?vue&type=script&lang=js&"
import style0 from "./ProRetouchersOrderEducationCheck.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports